const sideIcons = document.querySelector('.ce_rsce_sideIcons');

if (sideIcons && window.innerWidth < 600) {

    window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        if (scrollPosition >= pageHeight * 0.9) {
            sideIcons.style.display = 'block';
        } else {
            sideIcons.style.display = 'none';
        }
    });
}
